import React from "react";
import { Grid, Input, Dropdown, Button } from "semantic-ui-react";

const MergeCustomerFilter = ({ filterNameOrId,
    setFilterNameOrId,
    filterSiteId,
    setFilterSiteId,
    filterAgeRangeId,
    setFilterAgeRangeId,
    filterEthnicityId,
    setFilterEthnicityId,
    filterGenderId, 
    setFilterGenderId, 
    searchLoading, 
    runSearch, 
    searchMeta,
    }) => {
    const { ageRanges = [], ethnicity = [], genders = [], sites = [] } = searchMeta;
    return (
        <Grid stackable className="mt-2 mb-2" columns="equal">
            <Grid.Row verticalAlign="middle">
            <Grid.Column>
                <Input
                fluid
                placeholder="Search by name or ID"
                value={filterNameOrId}
                onChange={(_, { value }) => setFilterNameOrId(value)}
                />
            </Grid.Column>
            <Grid.Column>
                <Dropdown
                fluid
                placeholder="Home Venue"
                selection
                clearable
                options={sites.map((s) => ({
                    key: s.id,
                    value: s.id,
                    text: s.name,
                }))}
                value={filterSiteId}
                onChange={(_, { value }) => setFilterSiteId(value || null)}
                />
            </Grid.Column>
            <Grid.Column>
                <Dropdown
                fluid
                placeholder="Age Range"
                selection
                clearable
                options={ageRanges.map((a) => ({
                    key: a.id,
                    value: a.id,
                    text: a.name,
                }))}
                value={filterAgeRangeId}
                onChange={(_, { value }) => setFilterAgeRangeId(value || null)}
                />
            </Grid.Column>
            <Grid.Column>
                <Dropdown
                fluid
                placeholder="Ethnicity"
                selection
                clearable
                options={ethnicity.map((e) => ({
                    key: e.id,
                    value: e.id,
                    text: e.name,
                }))}
                value={filterEthnicityId}
                onChange={(_, { value }) => setFilterEthnicityId(value || null)}
                />
            </Grid.Column>
            <Grid.Column>
                <Dropdown
                fluid
                placeholder="Gender"
                selection
                clearable
                options={genders.map((g) => ({
                    key: g.id,
                    value: g.id,
                    text: g.name,
                }))}
                value={filterGenderId}
                onChange={(_, { value }) => setFilterGenderId(value || null)}
                />
            </Grid.Column>
            <Grid.Column width={2}>
                <Button
                fluid
                content="Search"
                onClick={runSearch}
                loading={searchLoading}
                primary
                size="mini"
                />
            </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}

export default MergeCustomerFilter;